<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

// console.log("Init custom js");
  
// document.addEventListener("DOMContentLoaded", function() {
//     // Select the element with data-index="4"
//     var targetElement = document.querySelector('.productView-image-adapt');
//       // document.querySelector('.productView-image-adapt[data-index="4"]');

//   // productView-image productView-image-adapt fit-contain slick-slide

//     console.log("Find element");
  
//     if (targetElement) {
//         // Change the opacity to 1
//         targetElement.style.opacity = "1";

//         var newh4 = document.createElement("h4");
//         newh4.textContent = "Styles available";
//         newh4.style.textTransform = "uppercase";
//         targetElement.appendChild(newh4);
        
//         // Create the new div
//         var newDiv = document.createElement("div");
//         newDiv.className = "horizontal-images";
//         newDiv.style.display = "flex"; // To arrange images horizontally
//         newDiv.style.gap = "10px"; // Optional: Adds space between images
//         // newDiv.style.paddingTop = "15px";

//         // List of image URLs
//         var imageUrls = [
//             "//footworkonline.myshopify.com/cdn/shop/files/image1.jpg",
//             "//footworkonline.myshopify.com/cdn/shop/files/image2.jpg",
//             "//footworkonline.myshopify.com/cdn/shop/files/image3.jpg"
//         ];

//         // Add images to the new div
//         imageUrls.forEach(function(url) {
//             var img = document.createElement("img");
//             img.src = url;
//             img.style.width = "100px"; // Optional: Set image width
//             img.style.height = "auto"; // Optional: Maintain aspect ratio
//             newDiv.appendChild(img);
//         });

//         // Append the new div to the target element
//         targetElement.appendChild(newDiv);
//     }
// });


  console.log("Init custom js");
  
// Create colour options elements on product page. 
document.addEventListener("DOMContentLoaded", function() {
    getImagesForProduct();
});

// Start of Colour Options calls to API.
console.log("Colour options init...");

// Create a Set to store checked URLs
const checkedUrls = new Set();

// Function to check for 404 and uniqueness
function check404(url) {
    return new Promise((resolve, reject) => {
        // If URL is already checked, resolve the promise with true
        if (checkedUrls.has(url)) {
            resolve(true);
            return;
        }

        // Add URL to the set of checked URLs
        checkedUrls.add(url);

        // Perform the fetch operation to check for 404
        fetch(url, { method: 'HEAD' })
            .then(response => {
                if (response.status === 404) {
                    console.log(`${response.status} is 404`);
                    resolve(true);
                } else {
                    resolve(false);
                }
            })
            .catch(error => {
                // Handle any other errors
                console.error(`Failed to fetch ${url}: ${error}`);
                reject(error);
            });
    });
}

const baseUrl = 'https://clsp.interbrandgroup.co.za/';
const getOptions = {
    method: "GET",
    mode: "cors",
    headers: {
        "Content-Type": "application/json",
    },
};
const url = window.location.hostname;
let tempProductHandle = window.location.pathname;
const productHandle = tempProductHandle.replace("/products/", "");

console.log("PRODUCT_HANDLE: ", productHandle);
console.log(baseUrl + `${productHandle}`);

function getImagesForProduct() {
    fetch(baseUrl + `${productHandle}`, getOptions)
        .then(response => response.json())
        .then(data => {
            console.log("DATA: ", data);
            for (let i = 0; i < data.length; i++) {
              // Delete after testing OPEN:
               // console.log("DATA[i]: ", data[i]);
               //              createColourOptionElements(data[i]);
              //Delete after testing CLOSE.
                check404(data[i].productHandle)
                    .then(isDraft => {
                        if (isDraft) {
                            // URL returned 404, handle accordingly
                        } else {
                            // URL is valid, handle accordingly
                          console.log("DATA[i]: ", data[i]);
                            createColourOptionElements(data[i]);
                        }
                    })
            }
        });
}

let newDivCreated = false;

// Create colour option elements on product page.
function createColourOptionElements(imageUrls) {
    // Select the element with data-index="4"
    // var targetElement = document.querySelector('.productView-image-adapt');
    // document.querySelector('.productView-image-adapt[data-index="4"]');
  var targetElement = document.querySelector('.productView-image-wrapper');
    console.log("Find element");

    if (targetElement) {
        // Change the opacity to 1
        targetElement.style.opacity = "1";

        if(!newDivCreated){
          var newh4 = document.createElement("h4");
          newh4.textContent = "Colours available";
          newh4.style.textTransform = "uppercase";
          targetElement.appendChild(newh4);
        }

        // Create the new div
      if(!newDivCreated){
        var newDiv = document.createElement("div");
        newDiv.className = "horizontal-images";
        newDiv.style.display = "flex"; // To arrange images horizontally
        newDiv.style.gap = "10px"; // Optional: Adds space between images
        // newDiv.style.paddingTop = "15px";
      } else {
        var newDiv = document.querySelector('.horizontal-images')
      }

      console.log("IMAGE_URLS: ", imageUrls);

        // Add images to the new div
        // imageUrls.forEach(function(url) {
            var img = document.createElement("img");
            img.src = imageUrls.src;
            img.style.width = "100px"; // Optional: Set image width
            img.style.height = "auto"; // Optional: Maintain aspect ratio

            var link = document.createElement("a");
            link.href = `/products/${imageUrls.productHandle}`;
            link.appendChild(img);

            newDiv.appendChild(link);
        // });

        // Append the new div to the target element
      if(!newDivCreated){
        targetElement.appendChild(newDiv);
        newDivCreated = true;
      }
        
    }
}

// getImagesForProduct();

console.log("Colour options completed.");
